import { createContext } from 'react';

import { SelectedPositionContextProps } from './SelectedPositionContext.types';

export const SelectedPositionContext = createContext<SelectedPositionContextProps | undefined>(undefined);
